import { render } from "./Results3.vue?vue&type=template&id=5e5e0b0a&scoped=true"
import script from "./Results3.vue?vue&type=script&lang=js"
export * from "./Results3.vue?vue&type=script&lang=js"

import "./Results3.vue?vue&type=style&index=0&id=5e5e0b0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5e0b0a"]])

export default __exports__